import Img from '@/shared/components/Img';

type Props = {
  game: GameFragment;
  height: number;
  showGrid?: boolean;
};

const MobileGameThumbnail: FC<Props> = ({ game, height, showGrid = false }) => {
  const width = calculateWidth(height);
  const style = {
    width: showGrid ? '100%' : `${width}px`,
    height: showGrid ? 'auto' : `${height}px`,
  };

  const src = game.thumbUrl ?? '';
  const alt = game.name ?? '';

  return (
    <Img
      src={src}
      alt={alt}
      width={width}
      height={height}
      dpr={2}
      className="relative rounded-moon-s-sm"
      style={style}
    />
  );
};

const calculateWidth = (height: number) => {
  const aspectRatio = 117 / 88;
  return height * aspectRatio;
};

export default MobileGameThumbnail;
